import LandingFormWrapper from 'components/landingFormWrapper/LandingFormWrapper';
import { userBasicInfoPublicPages } from 'modules/graphqlQueries';
import ContactForm from 'pageParts/contactForm/ContactForm';
import {
  Heading,
  Info,
  Row,
  SectionsTitle,
  SectionsTitleWrapper,
  Text,
  TitleLine,
} from 'styles/contact.styles';

import Layout from '../components/layout/Layout';
import { useLoadData } from '../modules/useLoadData';
import { UserType } from '../types/UserTypes';

const getQuery = (userId) => `{
  user(_id: "${userId}") {
    ${userBasicInfoPublicPages}
  }
}`;

const Contact = (): JSX.Element => {
  const {
    isLoading,
    response: {
      data: { user },
    },
  } = useLoadData(getQuery);

  return (
    <Layout user={user as UserType} isLoading={isLoading} noExtraSpaceFooter>
      <LandingFormWrapper size={1050}>
        <SectionsTitleWrapper>
          <SectionsTitle>Contact us</SectionsTitle>
        </SectionsTitleWrapper>
        <TitleLine />
        <Row>
          <Info>
            <Heading>Question? Problem? Feedback?</Heading>
            <Text>
              Talk to us and we will get back to you as soon as possible!
            </Text>
            <Heading>Looking for support?</Heading>
            <Text>
              Check our <a href="/support">support page</a> for more frequently
              asked questions
            </Text>
          </Info>
          <ContactForm companyName={user?.companyName} email={user?.email} />
        </Row>
      </LandingFormWrapper>
    </Layout>
  );
};

export default Contact;
